import React from 'react'

const Byline = (props) => (
  <p id="byline">
    {props.byline}
  </p>
)

export default Byline
